import PropTypes from 'prop-types'
import { useContext } from 'react'
import { useTranslation } from 'next-i18next'

// Context
import { ModalContext } from '../../context/ModalContext'

// Internal components
import Svg from '../Svg/Svg'
import { UserContext } from '../../context/UserContext'

const ModalBack = (props) => {
  const { routeLabel, routePath, routeId } = props

  const userContext = useContext(UserContext)
  // Translations
  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT
  )

  const modalContext = useContext(ModalContext)

  const updateModalRoute = () => {
    if (routeId) modalContext.setModalId(routeId)
    modalContext.setModalRoute(routePath)
  }

  return (
    <div className="ModalBack">
      <button className="ModalBack-button" onClick={() => updateModalRoute()}>
        <Svg id={'icon-chevron-left'} modifiers={['ModalBack-icon']} />
        <span className="ModalBack-label">{t(routeLabel)}</span>
      </button>
    </div>
  )
}

ModalBack.propTypes = {
  routeLabel: PropTypes.string.isRequired,
  routePath: PropTypes.string.isRequired,
  routeId: PropTypes.string
}

export default ModalBack
